export enum HrEmployeeCompensationModalMode {
  VIEW = "view",
}
